import type { ApplicationState } from "@/features/onboarding/onboarding.types";

// Single source of truth for the unified 8-segment journey — the submission
// form (OnboardingPage) renders Step 1 ("NEW_APPLICATION") on its own, and
// ApplicationReviewFlow renders steps 2-8 (the real ApplicationState values)
// with a permanent "complete" NEW_APPLICATION segment prepended, so both
// screens show the same continuous Stepper.
export type JourneyStepId = "NEW_APPLICATION" | ApplicationState;

export const JOURNEY_STEPS: { id: JourneyStepId; labelId: string }[] = [
  { id: "NEW_APPLICATION", labelId: "lender.onboarding.review.stepNewApplication" },
  { id: "READY_FOR_REVIEW", labelId: "lender.onboarding.review.stepVerification" },
  { id: "VERIFIED", labelId: "lender.onboarding.review.stepLoanTerms" },
  { id: "LOAN_DETAILS_VERIFICATION", labelId: "lender.onboarding.review.stepLoanDetailsVerified" },
  { id: "CIBIL_VERIFICATION", labelId: "lender.onboarding.review.stepCibil" },
  { id: "E_MANDATE", labelId: "lender.onboarding.review.stepEMandate" },
  { id: "NOTIFICATION_PENDING", labelId: "lender.onboarding.review.stepNotification" },
  { id: "COMPLETED", labelId: "lender.onboarding.review.stepCompleted" },
];

// The 7 real ApplicationState values, in order — the same slice of
// JOURNEY_STEPS minus the synthetic NEW_APPLICATION entry.
export const STATE_ORDER: ApplicationState[] = JOURNEY_STEPS.slice(1).map((step) => step.id as ApplicationState);
